export const getTerminalPackagesCode = {
    "curl": {
      "request": `curl -X 'GET'
    'https://demo-api.westpay.se/access/v2/terminal/getPackages/<customerId>/<model>'
    -H 'accept: text/plain'
    -H 'Ocp-Apim-Subscription-Key: <merchant-subscription-key>'
    -H 'Authorization: Bearer <access-token>'`
    },
    "java": {
      "request": `import java.io.IOException;
    import java.net.URI;
    import java.net.URISyntaxException;
    import java.net.http.HttpClient;
    import java.net.http.HttpHeaders;
    import java.net.http.HttpRequest;
    import java.net.http.HttpResponse;
    import java.util.concurrent.ExecutionException;
      
    public class Main {
        public static void main(String[] args) throws URISyntaxException, IOException, InterruptedException, ExecutionException {
            String url = "https://demo-api.westpay.se/access/v2/terminal/getPackages/<customerId>/<model>";
            String subscriptionKey = "<merchant-subscription-key>";
            String accessToken = "<access-token>";
      
            HttpClient httpClient = HttpClient.newHttpClient();
      
            HttpRequest request = HttpRequest.newBuilder()
                    .uri(new URI(url))
                    .header("accept", "text/plain")
                    .header("Ocp-Apim-Subscription-Key", subscriptionKey)
                    .header("Authorization", "Bearer " + accessToken)
                    .GET()
                    .build();
      
            HttpResponse<String> response = httpClient.send(request, HttpResponse.BodyHandlers.ofString());
      
            int statusCode = response.statusCode();
            HttpHeaders headers = response.headers();
            String responseBody = response.body();
      
            System.out.println("Status Code: " + statusCode);
            System.out.println("Response Headers: " + headers);
            System.out.println("Response Body: " + responseBody);
        }
    }
      `
    },
    "C#": {
      "request": `using System;
    using System.Net.Http;
    using System.Threading.Tasks;
      
    class Program
    {
        static async Task Main(string[] args)
        {
            string url = "https://demo-api.westpay.se/access/v2/terminal/getPackages/<customerId>/<model>";
            string subscriptionKey = "<merchant-subscription-key>";
            string accessToken = "<access-token>";
      
            using (HttpClient client = new HttpClient())
            {
                client.DefaultRequestHeaders.Add("accept", "text/plain");
                client.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", subscriptionKey);
                client.DefaultRequestHeaders.Add("Authorization", "Bearer " + accessToken);
      
                HttpResponseMessage response = await client.GetAsync(url);
      
                if (response.IsSuccessStatusCode)
                {
                    string responseBody = await response.Content.ReadAsStringAsync();
                    Console.WriteLine(responseBody);
                }
                else
                {
                    Console.WriteLine("Error: " + response.StatusCode);
                }
            }
        }
    }
      `
    },
    "python": {
      "request": `import requests

    url = "https://demo-api.westpay.se/access/v2/terminal/getPackages/<customerId>/<model>"
    subscription_key = "<merchant-subscription-key>"
    access_token = "<access-token>"
      
    headers = {
        "accept": "text/plain",
        "Ocp-Apim-Subscription-Key": subscription_key,
        "Authorization": "Bearer " + access_token
    }
      
    response = requests.get(url, headers=headers)
      
    if response.status_code == 200:
        print(response.text)
    else:
        print("Error:", response.status_code)
      `
    },
    
    "JavaScript": {
      "request": `const url = 'https://demo-api.westpay.se/access/v2/terminal/getPackages/<customerId>/<model>';
    const subscriptionKey = '<merchant-subscription-key>';
    const accessToken = '<access-token>';
      
    const headers = {
      'accept': 'text/plain',
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      'Authorization': 'Bearer ' + accessToken
    };
      
    fetch(url, { headers })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(responseText => {
        console.log(responseText);
      })
      .catch(error => {
        console.error('There was a problem with your fetch operation:', error);
      });
      `
    }
  };

  export const getTerminalPackagesCodeResponse = `{
        "packageInfo": [
          {
            "id": "<package_id>",
            "timeCreated": "<timeCreated>", // Timestamp when the package was created
            "timeModified": "<timeModified>", // Timestamp when the package was last modified
            "name": "<name>", // Name of the package
            "notes": "<notes>", // Additional notes or comments about the package
            "modelName": "<modelName>", // Model name associated with the package
            "modelId": "<modelId>", // ID of the model associated with the package
            "category": "<category>", // Category of the package
            "categoryId": "<categoryId>" // ID of the category associated with the package
          }
        ]
      }
      `;
  